import { Injectable } from '@angular/core';
import {Loading, LoadingController, Nav, NavController} from "ionic-angular";

/*
  Generated class for the LoadingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoadingProvider {

  private loading: Loading;
  constructor(private loadingCtrl: LoadingController) {}

  async show(msg: string) {
    await this.dismiss();

    this.loading = this.loadingCtrl.create({
      content: msg,
      duration: 30000
    });
    await this.loading.present();
  }

  async dismiss() {
    if(this.loading && this.loading.instance) {
      this.loading.dismiss();
      this.loading = undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/loading/loading.ts